export default __webpack_public_path__ + "static/media/clara-ai.007fd5fd.jpg";